
import EarnableRewardsCallout from 'JS/checkout/components/common/EarnableRewardsCallout.vue';
import Icon from 'JS/components/Icon.vue';
import InstallationQuoteLineItem from './InstallationQuoteLineItem.vue';
import InstallationQuoteOptionalLineItem from './InstallationQuoteOptionalLineItem.vue';
import OrderSummaryLine from 'JS/components/order/OrderSummaryLine.vue';
import PromoOfferDiscountLine from 'JS/components/order/PromoOfferDiscountLine.vue';
import RoadHazardProtectionModal from '../RoadHazardProtectionModal.vue';
import { computed, defineComponent, ref } from 'vue';
import { getOfferIndicatorFromPromoOfferBucket, OfferBucketLabelMap, OfferBucketToDisplayTypeMap } from 'JS/helpers/promo-helpers';
import { IAutomotiveWorkOrderLineItem, IAutomotiveWorkOrderQuoteSummary } from 'JS/types/automotive/WorkOrderQuote';
import { PromoOfferBucket } from 'JS/types/Promo';
import { PropType } from 'vue';

export default defineComponent({
	name: 'InstallationQuote',
	components: {
		PromoOfferDiscountLine,
		RoadHazardProtectionModal,
		OrderSummaryLine,
		InstallationQuoteOptionalLineItem,
		InstallationQuoteLineItem,
		Icon,
		EarnableRewardsCallout
	},
	props: {
		qty: { type: Number, required: true },
		blainNumber: { type: String, required: true },
		quote: { type: Object as PropType<IAutomotiveWorkOrderQuoteSummary> },
		selectedAddOns: { type: Set as PropType<Set<string>>, required: true },
		loading: Boolean,
		loadingComplete: Boolean,
		maxQuantityExceeded: { type: Boolean, required: true },
	},
	setup(props, { emit }) {
		const showHazardProtectionModal = ref(false);
		const potentialRewardsString = computed(() => props.quote.estimatedRewardsPoints.toFixed(2).toString());

		function checkLineItem({ blainNumber }: IAutomotiveWorkOrderLineItem) {
			emit('check-item', blainNumber);
		}

		const mailInRebates = computed(
			() => props?.quote?.promos?.filter(p => p.promoType === PromoOfferBucket.MailInRebate)
				.map(p => ({
					...p,
					indicator: getOfferIndicatorFromPromoOfferBucket(p.promoType),
					label: OfferBucketLabelMap[p.promoType],
				})) ?? []
		);

		const promos = computed(() => props.quote?.promos?.filter(p => p.promoType !== PromoOfferBucket.MailInRebate).map(promo => ({
			...promo,
			promoType: OfferBucketToDisplayTypeMap[promo.promoType],
		})));

		return {
			showHazardProtectionModal,
			checkLineItem,
			potentialRewardsString,
			formatDisplayPrice(price: number) {
				if (props.loading) {
					return "-";
				}

				return formatPrice(price);
			},
			formatPrice,
			promos,
			mailInRebates
		};
	}
});

function formatPrice(price: number): string {
	return '$' + Math.abs(price).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
